export default __webpack_public_path__ + "static/media/azuki.25b3f10b.png";